import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

function WidgetSidebar({ children, onToggle }) {
  const { t } = useTranslation()

  const {
    common: { isNative }
  } = useSelector((state) => state)

  const [isExpanded, setIsExpanded] = useState(true)
  const handleToggle = () => {
    const updatedState = !isExpanded
    if (onToggle) {
      onToggle(updatedState)
    }
    setIsExpanded(updatedState)
  }
  return children ? (
    <div
      className={`${styles.widgetSidebarContainer} ${isNative && styles.isNativeSidebarContainer} ${
        isExpanded ? styles.expanded : styles.collapsed
      }`}>
      <button
        aria-label={isExpanded ? t('widgets.hide') : t('widgets.show')}
        className={styles.toggler}
        onClick={handleToggle}>
        <Icon size='large24' name={isExpanded ? 'burger-expand' : 'burger-collapse'} />
      </button>

      <div className={styles.widgets}> {children}</div>
    </div>
  ) : null
}

export default WidgetSidebar
